import { PaginationHandler, PaginationInfo, PAGE_SIZE } from '@occc-app/hooks/usePaginatedQuery';

import { useQueryParam } from './useQueryParam';

export const AFTER_PARAM = 'after';
export const BEFORE_PARAM = 'before';

export type UsePaginationProps = {
  pageSize?: number;
  afterParamName?: string;
  beforeParamName?: string;
};

export const usePaginationParams = ({
  pageSize = PAGE_SIZE,
  afterParamName = AFTER_PARAM,
  beforeParamName = BEFORE_PARAM,
}: UsePaginationProps = {}): [PaginationInfo, PaginationHandler] => {
  const [paginationInfo, setPaginationInfo] = useQueryParam<PaginationInfo>(
    (searchParams) => {
      const after = searchParams.get(afterParamName);
      const before = searchParams.get(beforeParamName);

      const paginationInfo: PaginationInfo = {
        after,
        before,
        first: !before ? pageSize : null,
        last: before ? pageSize : null,
      };

      return paginationInfo;
    },
    (value, searchParams) => {
      if (value.after && value.before) {
        throw new Error('You should not use `after` and `before` params at the same time');
      }

      if (value.after) {
        searchParams.set(afterParamName, value.after);
        searchParams.delete(beforeParamName);
      }

      if (value.before) {
        searchParams.set(beforeParamName, value.before);
        searchParams.delete(afterParamName);
      }
    },
  );

  return [paginationInfo, setPaginationInfo];
};

export const deletePaginationParams = (
  searchParams: URLSearchParams,
  beforeParamName = BEFORE_PARAM,
  afterParamName = AFTER_PARAM,
) => {
  searchParams.delete(beforeParamName);
  searchParams.delete(afterParamName);
};
